import axios from "axios";
import Utils from "./Utils";

class AzureBlobUploadHelper {
  static requestSasToken({ psid, purpose, fileName }) {
    return axios
      .get(Utils.apiUrl("photoshoot/blob-sas"), {
        params: {
          psid,
          purpose,
          fileName,
        },
        headers: {
          ...Utils.apiHeaders().headers,
        },
      })
      .then((res) => {
        if (!res.data?.success || !res.data?.sasUrl) {
          throw new Error(
            res.data?.message || "Unable to generate upload token.",
          );
        }
        return {
          sasUrl: res.data.sasUrl,
          blobUrl: res.data.blobUrl,
          blobName: res.data.blobName,
        };
      });
  }

  static uploadFileWithSas({ file, sasUrl }) {
    return axios.put(sasUrl, file, {
      headers: {
        "x-ms-blob-type": "BlockBlob",
        "Content-Type": file.type || "application/octet-stream",
      },
    });
  }

  static async upload({ psid, purpose, file }) {
    if (!file) {
      throw new Error("No file selected for upload.");
    }

    const sasData = await AzureBlobUploadHelper.requestSasToken({
      psid,
      purpose,
      fileName: file.name,
    });

    await AzureBlobUploadHelper.uploadFileWithSas({
      file,
      sasUrl: sasData.sasUrl,
    });

    return {
      blobUrl: sasData.blobUrl,
      blobName: sasData.blobName,
    };
  }
}

export default AzureBlobUploadHelper;
